(function () {
  // Biscuits Bundles <-> personalisatie + thema cart-drawer bridge.
  //
  // Biscuits voegt een bundle toe via een eigen, atomische /cart/add call (alle
  // bundle-onderdelen in EEN request, herkenbaar aan de "_bundleId" property).
  // Daar haken we op in om de personalisatie mee te nemen:
  //   1. De properties (kaartje/lint checkbox + tekst) worden op de bundle-items gezet.
  //   2. De losse companion-PRODUCTEN (Gepersonaliseerd Kaartje / Lint) worden aan
  //      dezelfde request toegevoegd, met dezelfde tekst als property.
  // Daarna openen we de thema cart-drawer via de officiele thema-hook 'cart:refresh'
  // (Biscuits herkent dit thema niet en opent de drawer zelf niet).
  //
  // Voor gewone (niet-bundle) producten regelt het <personalize-fields> element dit
  // zelf in de normale product-form flow; dit script raakt die niet aan.
  if (window.__biscuitsCartBridgeInitialized) return;
  window.__biscuitsCartBridgeInitialized = true;

  function isCartAdd(url) {
    var u = String(url);
    return u === '/cart/add' || u === '/cart/add.js' || /\/cart\/add(\.js)?(\?|$)/.test(u);
  }

  function widget() {
    return document.querySelector('personalize-fields');
  }

  function openDrawer() {
    if (!document.querySelector('cart-drawer')) return;
    document.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
    );
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : String(input);

    if (isCartAdd(url) && init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        var bundleItems = (body.items || []).filter(function (i) {
          return i.properties && i.properties._bundleId !== undefined;
        });

        if (bundleItems.length) {
          var w = widget();
          if (w && typeof w.getCompanionItems === 'function') {
            var props = w.getProperties();
            var companions = w.getCompanionItems(1);

            // 1. Zet de personalisatie-properties op de bundle-items (bestaande
            //    bundle-properties blijven leidend bij conflict).
            if (Object.keys(props).length) {
              body.items = body.items.map(function (item) {
                if (item.properties && item.properties._bundleId !== undefined) {
                  return Object.assign({}, item, {
                    properties: Object.assign({}, props, item.properties),
                  });
                }
                return item;
              });
            }

            // 2. Voeg de losse companion-producten toe aan dezelfde request.
            if (companions.length) {
              body.items = body.items.concat(companions);
            }

            init = Object.assign({}, init, { body: JSON.stringify(body) });
          }

          var result = origFetch.call(this, input, init);
          result
            .then(function (r) {
              if (r && r.ok) openDrawer();
            })
            .catch(function () {});
          return result;
        }
      } catch (e) {
        // Geen JSON-body of parse-fout: val terug op de normale fetch.
      }
    }

    return origFetch.apply(this, arguments);
  };

  // Vangnet: mocht Biscuits ooit zonder _bundleId-payload toevoegen, dan openen we
  // de drawer alsnog op het officiele success-event.
  document.addEventListener('biscuits--add-to-cart-success', openDrawer);
})();
